/** The tooltip both edit forms show beside the field. */
export const GOOGLE_BUSINESS_URL_TOOLTIP =
  'Customers who rate their delivery 4-5 stars on the tracking page are offered this link to review the restaurant on Google.';

/**
 * What saving the Google My Business field means, before anything is sent:
 * `unchanged` sends nothing (the link has its own route, called only when it
 * changes), `invalid` stops the save with the backend's own rule - an
 * http(s) URL - and `value` is what to send, `null` clearing the link.
 */
export const googleBusinessUrlChange = (
  saved: string | null | undefined,
  input: string
):
  | { kind: 'unchanged' }
  | { kind: 'invalid' }
  | { kind: 'set'; value: string | null } => {
  const value = input.trim() || null;
  if (value === (saved ?? null)) return { kind: 'unchanged' };
  if (value && !/^https?:\/\//i.test(value)) return { kind: 'invalid' };
  return { kind: 'set', value };
};
